import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
let Datetime = class Datetime extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      required: "1",
      jsonConfig: {
        showIndex: true,
        dateType: "date",
        minDateType: "",
        maxDateType: "",
        minRequirementDate: "",
        maxRequirementDate: ""
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      "jsonConfig.minDateType": [{
        validator: this.validatorMinDateType,
        trigger: "blur"
      }],
      "jsonConfig.maxDateType": [{
        validator: this.validatorMaxDateType,
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  get dateFormat() {
    let date = "yyyy-MM-dd";
    if (this.postForm.jsonConfig.dateType == "datehour") {
      date = "yyyy-MM-dd HH";
    }
    if (this.postForm.jsonConfig.dateType == "datetime") {
      date = "yyyy-MM-dd HH:mm";
    }
    return date;
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validatorMinDateType(rule, value, callback) {
    if (this.postForm.jsonConfig.minDateType == "requirementDate" && !this.postForm.jsonConfig.minRequirementDate) {
      callback(new Error("请选择起始时间"));
    } else if (this.postForm.jsonConfig.minDateType == "requirementDate" && this.postForm.jsonConfig.maxDateType == "requirementDate" && new Date(this.postForm.jsonConfig.minRequirementDate) > new Date(this.postForm.jsonConfig.maxRequirementDate)) {
      callback(new Error("起始时间需小于截止时间"));
    } else {
      callback();
    }
  }
  validatorMaxDateType(rule, value, callback) {
    if (this.postForm.jsonConfig.maxDateType == "requirementDate" && !this.postForm.jsonConfig.maxRequirementDate) {
      callback(new Error("请选择截止时间"));
    } else if (this.postForm.jsonConfig.minDateType == "requirementDate" && this.postForm.jsonConfig.maxDateType == "requirementDate" && new Date(this.postForm.jsonConfig.minRequirementDate) > new Date(this.postForm.jsonConfig.maxRequirementDate)) {
      callback(new Error("起始时间需小于截止时间"));
    } else {
      callback();
    }
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], Datetime.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], Datetime.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], Datetime.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], Datetime.prototype, "watchPostForm", null);
Datetime = __decorate([Component({
  name: "Datetime",
  components: {
    questionSettingTemplate
  }
})], Datetime);
export default Datetime;